import React, { useState, useEffect } from 'react';
import { Modal, Button, Container, Row, Col } from 'react-bootstrap';
import Swal from 'sweetalert2';
import RequestServies from '../../../services/RequestServies';

const MivForm = ({ show, handleClose, store, onSuccess }) => {
  const initialFormValues = {
    mivNo: 0,
    store: '',
  };

  const [formValues, setFormValues] = useState(initialFormValues);
  const [previewImage, setPreviewImage] = useState('img/placeholder-img.png');

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setFormValues({
      ...formValues,
      [name]: value,
    });
  };

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setPreviewImage(reader.result);
      };
      reader.readAsDataURL(file);
      setFormValues({
        ...formValues,
        image: file,
      });
    }
  };

  // Validate form fields and display Swal alerts
  const validateForm = () => {
    if (!formValues.mivNo || formValues.mivNo <= 0) {
      Swal.fire({
        icon: 'warning',
        title: 'Missing MIV No',
        text: 'Please enter a valid MIV number.',
      });
      return false;
    }

    if (!formValues.store) {
      Swal.fire({
        icon: 'warning',
        title: 'Missing Store',
        text: 'Please select a store from the list.',
      });
      return false;
    }

    if (!formValues.image) {
      Swal.fire({
        icon: 'warning',
        title: 'Missing Image',
        text: 'Please upload an image.',
      });
      return false;
    }

    return true;
  };


  const handleSubmit = async (event) => {
    event.preventDefault();

    // Validate the form before submitting
    if (!validateForm()) {
      return;
    }

    try {
      const formData = new FormData();
      for (const key in formValues) {
        if (key !== 'image' || formValues[key] instanceof File) {
          formData.append(key, formValues[key]);
        }
      }

      await RequestServies.createMiv(formData);
      Swal.fire('Success', 'Miv Form Added Successfully!', 'success');
      onSuccess();
      handleClose();
    } catch (error) {
      console.error('Failed to Add Miv Form');
      Swal.fire('Error', error.response.data.message || 'Failed to add Miv Form', 'error');
    }
  };

  // Reset form values when the modal is closed
  useEffect(() => {
    if (!show) {
      setFormValues(initialFormValues); // Reset form to initial state
      setPreviewImage('img/placeholder-img.png'); // Reset image preview
    }
  }, [show]); // Trigger when the modal visibility changes

  return (
    <Modal className="fade" show={show} onHide={handleClose}>
      <form onSubmit={handleSubmit}>
        <Modal.Header>
          <Modal.Title>
            <i className="fas fa-edit"></i> Miv Form
          </Modal.Title>
          <Button variant="" className="btn-close" onClick={handleClose}></Button>
        </Modal.Header>
        <Modal.Body>
          <Container>
            <Row>
              <Col md="6">
                <label>Miv No</label>
                <input
                  type="number"
                  name="mivNo"
                  className="form-control form-control-sm"
                  value={formValues.mivNo}
                  onChange={handleInputChange}
                  placeholder=""
                />
              </Col>
              <Col md="6">
                <label>Store</label>
                <select
                  name="store"
                  className="form-control form-control-sm"
                  value={formValues.store}
                  onChange={handleInputChange}
                >
                  <option value="">Select a Store</option>
                  {store.map((s) => (
                    <option key={s._id} value={s._id}>
                      {s.name}
                    </option>
                  ))}
                </select>
              </Col>
            </Row>
            <Row>
              <Col md="6">
                <label>Upload Image</label>
                <input
                  type="file"
                  name="photo"
                  accept="image/*"
                  capture="environment"
                  className="form-control form-control-sm"
                  onChange={handleFileChange}
                />

                <div className="file-preview text-center">
                  <img
                    id="uploadFile"
                    src={previewImage}
                    alt="Preview"
                    className="img-fluid"
                  />
                </div>
              </Col>
            </Row>
          </Container>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="danger light" onClick={handleClose}>
            Close
          </Button>
          <Button variant="primary" type="submit">
            Save changes
          </Button>
        </Modal.Footer>
      </form>
    </Modal>
  );
};

export default MivForm;
